import { mapModelSchema } from '@/models/mapSchema';
import { store } from '@/redux/store';
import type { MapModel as PluginMapModel } from 'minerva-plugin-api';
import { validateDataUsingZodSchema } from '@/utils/validateDataUsingZodSchema';
import { z } from 'zod';
import { toPluginMapModel } from '@/services/pluginsManager/adapters/toPluginMapModel';

export const getModels = (): PluginMapModel[] => {
  const models = store.getState().models.data;

  const isDataValid = validateDataUsingZodSchema(models, z.array(mapModelSchema));

  return isDataValid ? models.map(toPluginMapModel) : [];
};
